"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const svgs_1 = require("@@/assets/svgs");
const string_utils_1 = require("@/common/string_utils");
function default_1({ like_counts, view_counts, isHotLike, }) {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            display: 'flex',
            alignItems: 'center',
            columnGap: '3px',
            span: {
                flexShrink: 0,
                fontSize: '12px',
            },
        } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.LikeHeartIconSvg, {}), (0, jsx_runtime_1.jsx)("span", Object.assign({ css: { color: 'rgba(0, 0, 0, 0.4)' } }, { children: (0, string_utils_1.money)(like_counts || 0) })), !isHotLike && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(svgs_1.ViewCountIconSvg, {}), (0, jsx_runtime_1.jsx)("span", Object.assign({ css: { color: 'rgba(0, 0, 0, 0.4)' } }, { children: (0, string_utils_1.money)(view_counts || 0) }))] }))] })));
}
exports.default = default_1;
